import { useLanguage } from '../context/LanguageContext';

export default function LanguageToggle({ className = '' }) {
  const { lang, toggleLang } = useLanguage();

  return (
    <button
      onClick={toggleLang}
      data-testid="language-toggle"
      className={`flex items-center gap-1.5 bg-card border border-border rounded-full px-2.5 py-1.5 shadow-lg hover:border-brand/50 transition-colors ${className}`}
    >
      <span className={`font-heading text-xs tracking-wide ${lang === 'en' ? 'text-brand' : 'text-muted-foreground'}`}>EN</span>
      <span className="text-muted-foreground text-xs">|</span>
      <span className={`font-heading text-xs tracking-wide ${lang === 'ja' ? 'text-brand' : 'text-muted-foreground'}`}>JP</span>
    </button>
  );
}
